
import $ from 'jquery';
import debounce from 'lodash.debounce';
import Insert from '../utilities/Insert';
import Icons from './Icons';
import Breakpoint from '../utilities/Breakpoint';
import TouchDevice from '../utilities/TouchDevice';

const navMain = document.querySelector( '.navMain' );
const subMenus = document.querySelectorAll( '.navMain-submenuWrapper--level-1' );
const navBarWrapper = document.querySelector( '.navBar-wrapper' );

function setNavMainHeight() {
	if ( Breakpoint.get() === 'desktop' ) {
		navBarWrapper.removeAttribute( 'style' );
		return;
	}
	navBarWrapper.setAttribute( 'style', `height:${window.innerHeight}px` );
}

function addSubMenuAria() {
	[...subMenus].forEach( ( submenu, index ) => {
		submenu.setAttribute( 'aria-hidden', true );
		submenu.setAttribute( 'id', `nav-main-submenu-wrapper-${index + 1}` );
	} );
}

function addMobileNav() {
	if ( Breakpoint.get() === 'desktop' ) {
		return;
	}

	[...subMenus].forEach( ( submenu, index ) => {
		const button = document.createElement( 'button' );
		button.setAttribute( 'aria-expanded', false );
		button.setAttribute( 'aria-controls', `nav-main-submenu-wrapper-${index + 1}` );
		button.classList.add( 'navMain-submenu-toggle' );
		button.innerHTML = Icons.arrowRight;
		Insert.before( button, submenu );
	} );

	navMain.setAttribute( 'data-nav', 'mobile' );
}

function toggleMobileSubMenu( button ) {
	const targetId = button.getAttribute( 'aria-controls' );
	const targetSubMenu = document.getElementById( targetId );
	const isHidden = button.getAttribute( 'aria-expanded' ) === 'false';

	button.setAttribute( 'aria-expanded', isHidden );
	targetSubMenu.setAttribute( 'aria-hidden', !isHidden );
	button.parentElement.classList.toggle( 'is-submenu-open' );

	$( targetSubMenu ).slideToggle();
}

function addDesktopNav() {
	if ( Breakpoint.get() === 'mobile' ) {
		return;
	}

	[...subMenus].forEach( ( submenu, index ) => {
		const link = submenu.previousElementSibling;
		link.classList.add( 'has-submenu' );
		link.parentNode.classList.add( 'contains-submenu' );
		link.setAttribute( 'aria-expanded', false );
		link.setAttribute( 'aria-controls', `nav-main-submenu-wrapper-${index + 1}` );
		link.insertAdjacentHTML( 'beforeend', Icons.arrowRight );
	} );

	navMain.setAttribute( 'data-nav', 'desktop' );
}

function handleResize() {
	// From desktop to mobile
	if ( navMain.getAttribute( 'data-nav' ) === 'desktop' && Breakpoint.get() === 'mobile' ) {
		[...subMenus].forEach( ( submenu ) => {
			const link = submenu.previousElementSibling;
			const icon = link.querySelector( '.svgIcon' );
			link.removeAttribute( 'aria-expanded' );
			link.removeAttribute( 'aria-controls' );
			link.removeChild( icon );
		} );
		addMobileNav();
	}

	// From mobile to desktop
	if ( navMain.getAttribute( 'data-nav' ) === 'mobile' && Breakpoint.get() === 'desktop' ) {
		[...subMenus].forEach( ( submenu ) => {
			const button = submenu.parentNode.querySelector( 'button' );
			submenu.parentNode.removeChild( button );
		} );
		addDesktopNav();
	}

	setNavMainHeight();
}

function handleTabletLandscape() {
	if ( Breakpoint.get() === 'desktop' && TouchDevice.get() === true ) {
		const links = navMain.querySelectorAll( '.has-submenu' );
		navMain.addEventListener( 'click', ( e ) => {
			if ( e.target.classList.contains( 'has-submenu' ) ) {
				if ( !e.target.classList.contains( 'is-open' ) ) {
					e.preventDefault();
				}

				[...links].forEach( ( link ) => {
					link.classList.remove( 'is-open' );
				} );
				e.target.classList.add( 'is-open' );
			}
		} );
	}
}

function initEvents() {
	navMain.addEventListener( 'click', ( e ) => {
		if ( e.target.classList.contains( 'navMain-submenu-toggle' ) ) {
			toggleMobileSubMenu( e.target );
		}
	} );

	window.addEventListener( 'resize', debounce( handleResize, 250 ) );
}

function init() {
	addSubMenuAria();
	addMobileNav();
	addDesktopNav();
	handleTabletLandscape();
	initEvents();
	setNavMainHeight();
}

export default {
	init,
};
